import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { Task } from '../../models/Task';

const TaskQueueUpdateCommand = Command.extend({
  detail: Task
}).defaultTo(
  generateDefault({
    action: commandList.TASK_QUEUE_UPDATE
  })
);

export { TaskQueueUpdateCommand };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/commands/Task.js
 **/